// import PropTypes from "prop-types";

import ChartkickChart from "../../../shared_components/chartkick_chart";

class GlobalChangeOverTimeChart extends ChartkickChart {
}

GlobalChangeOverTimeChart.propTypes = Object.assign({}, ChartkickChart.propTypes, {
});

export default GlobalChangeOverTimeChart;
